import { InjectionToken } from '@angular/core';

export const LY_DIALOG_DATA = new InjectionToken('LyDialogData');
